export enum Role {
  PPG_ADMIN = 'ppg-admin',
  PPG_MANAGER = 'ppg-manager',
  PPG_DEMO_USER = 'ppg-demo-user',
  CUSTOMER_ADMIN = 'admin',
  CUSTOMER_MANAGER = 'manager',
  CUSTOMER_USER = 'user',
  UNVERIFIED_USER = 'unverified-user',
}
